/* Clon dren — ajustes propios del clon sobre el tema fuente.
 * 1. Viste el botón de EasySell de esta tienda igual que el de la página fuente (que también es EasySell,
 *    configurado distinto). No toca el formulario de la app: solo estilo, animación y texto del botón.
 * 2. Red de seguridad: si animations.js no corre, las secciones con scroll-trigger se muestran igual.
 * Observadores convergentes (gotchas §E): compara antes de escribir, desconecta mientras escribe, se apaga a los 8 s.
 */
/* 3. Velocidad: ningún vídeo arranca antes de que su sección esté cerca de la pantalla. El carrusel de la fuente
 *    reproduce el vídeo activo al iniciarse aunque esté abajo, y eso bajaba 2,5 MB al abrir la página. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) || !window.HTMLMediaElement) return;
  var play = HTMLMediaElement.prototype.play, pause = HTMLMediaElement.prototype.pause;
  var cerca = new WeakSet(), esperando = new Map(), quiere = new WeakSet();
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      cerca.add(e.target); io.unobserve(e.target);
      (esperando.get(e.target) || []).forEach(function (v) { if (quiere.has(v)) play.call(v).catch(function () {}); });
      esperando.delete(e.target);
    });
  }, { rootMargin: '300px 0px' });
  HTMLMediaElement.prototype.play = function () {
    var sec = this.closest && this.closest('.shopify-section');
    if (this.tagName !== 'VIDEO' || !sec || cerca.has(sec)) return play.apply(this, arguments);
    if (!esperando.has(sec)) { esperando.set(sec, []); io.observe(sec); }
    var lista = esperando.get(sec);
    if (lista.indexOf(this) < 0) lista.push(this);
    quiere.add(this);
    return Promise.resolve();
  };
  HTMLMediaElement.prototype.pause = function () {
    quiere.delete(this);
    return pause.apply(this, arguments);
  };
})();

(function () {
  'use strict';
  var FUENTE = {
    styles: {
      'color': '#FFFFFF', 'font-size': '17px', 'background': '#20b90d', 'font-weight': '700',
      'border-color': '#ffffff', 'border-style': 'solid', 'border-width': '0px', 'border-radius': '5px'
    },
    titulo: '¡PIDE Y PAGA EN CASA!',
    subtitulo: 'Envío Gratis a todo el Perú',
    animacion: 'es-animation-tada'
  };

  function setIf(el, prop, val) {
    if (el.style.getPropertyValue(prop) !== val || el.style.getPropertyPriority(prop) !== 'important') {
      el.style.setProperty(prop, val, 'important');
    }
  }
  function textIf(el, val) {
    if (el && el.textContent !== val) el.textContent = val;
  }

  function vestir() {
    var bs = document.querySelectorAll('.es-popup-button');
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i];
      for (var p in FUENTE.styles) setIf(b, p, FUENTE.styles[p]);
      var anims = [];
      b.classList.forEach(function (c) { if (/^es-animation-/.test(c) && c !== 'es-animation-active' && c !== FUENTE.animacion) anims.push(c); });
      anims.forEach(function (c) { b.classList.remove(c); });
      if (!b.classList.contains(FUENTE.animacion)) b.classList.add(FUENTE.animacion);
      textIf(b.querySelector('.es-button-title'), FUENTE.titulo);
      textIf(b.querySelector('.es-button-subtitle'), FUENTE.subtitulo);
      // La fuente pinta la bolsa con la fuente de iconos Bootstrap, que aqui carga tarde (la primera pantalla sale
      // sin bolsa): se dibuja el mismo icono (bi-bag-fill) en SVG, una sola vez.
      var ic = b.querySelector('i');
      if (!ic) {
        var caja = document.createElement('div');
        caja.style.margin = '0 10px';
        ic = document.createElement('i');
        caja.appendChild(ic);
        b.insertBefore(caja, b.firstChild);
      }
      if (ic.className) ic.className = '';   // sin la clase de la fuente de iconos: solo el SVG, que pinta al instante
      if (!ic.querySelector('svg.dren-bolsa')) {
        ic.innerHTML = '<svg class="dren-bolsa" xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4z"/></svg>';
      }
    }
    return bs.length;
  }

  var obs = null, pendiente = false, t0 = Date.now(), corridas = 0;
  function tick() {
    pendiente = false;
    if (obs) obs.disconnect();
    vestir();
    corridas++;
    if (Date.now() - t0 < 8000 && corridas < 60 && obs) {
      obs.observe(document.body, { childList: true, subtree: true });
    } else if (obs) {
      obs = null;
    }
  }
  function programar() {
    if (!pendiente) { pendiente = true; requestAnimationFrame(tick); }
  }
  function iniciar() {
    vestir();
    if ('MutationObserver' in window) {
      obs = new MutationObserver(programar);
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { if (obs) { obs.disconnect(); obs = null; } vestir(); }, 8000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();

  // Red de seguridad de apariciones: a los 2,5 s todo scroll-trigger queda visible.
  setTimeout(function () {
    var xs = document.querySelectorAll('.scroll-trigger--offscreen');
    for (var j = 0; j < xs.length; j++) xs[j].classList.remove('scroll-trigger--offscreen');
  }, 2500);
})();
